var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 66,
    viewBox: "0 0 595 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3641 29.2284C61.7352 29.5465 62.9721 29.7586 63.3432 29.8647C63.838 29.9707 64.9512 30.0768 65.3223 30.5009C63.7143 29.0163 63.3432 27.2135 63.9617 25.6228C64.5801 24.1381 65.5697 22.7595 64.5801 20.8507C64.4564 20.6386 62.8484 20.3205 62.6011 20.2144C62.3537 20.1084 60.7456 19.7902 60.6219 19.5781C61.6115 21.487 60.6219 22.8656 60.0035 24.3502C59.385 26.047 59.7561 27.7437 61.3641 29.2284Z",
    fill: "#FFD336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.025 13.9578C128.902 12.049 125.438 12.155 125.562 14.0639C125.686 15.9727 129.149 15.8667 129.025 13.9578Z",
    fill: "#FFD336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.889 16.0794C154.013 17.352 156.24 17.2459 156.24 15.9734C156.116 14.7008 153.766 14.8069 153.889 16.0794Z",
    fill: "#F42B75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.136 6.42969H80.291C80.9095 7.17201 82.3938 7.17201 83.136 6.42969Z",
    fill: "#3CA8F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3704 43.9154C75.4941 45.8243 78.9576 45.7182 78.8339 43.8094C78.7102 41.9006 75.2467 42.0066 75.3704 43.9154Z",
    fill: "#3CA8F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38281 64.1966C4.50651 65.4692 6.73302 65.3631 6.73302 64.0906C6.73302 62.818 4.38281 62.924 4.38281 64.1966Z",
    fill: "#FF639E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6141 22.4388C49.7378 23.7113 51.9643 23.6053 51.9643 22.3327C51.8406 21.0602 49.4904 21.1662 49.6141 22.4388Z",
    fill: "#FFD336"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.381 29.1264L125.02 27.4297L124.278 29.3385L121.928 29.9748L123.907 31.1413L123.783 33.2623L125.762 32.0957L127.989 32.732L127.247 30.8232L128.731 29.1264H126.381Z",
    fill: "#00DDC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4765 21.5928C3.72389 19.6839 0.260467 19.3658 0.0130784 21.2746C-0.23431 23.1835 3.10542 23.5016 3.4765 21.5928Z",
    fill: "#FF639E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3607 44.605C26.237 44.3929 24.8764 44.2869 24.629 44.2869C24.3816 44.2869 23.021 44.1808 22.8973 43.9688C23.6394 45.3474 22.5262 46.4078 21.9077 47.5743C21.1655 48.8469 21.4129 50.2255 22.6499 51.1799C22.8973 51.392 24.0105 51.392 24.3816 51.4981C24.7527 51.6041 25.7423 51.6041 26.1133 51.8162C24.8764 50.8618 24.629 49.4832 25.3712 48.2106C26.1133 47.0441 27.1029 45.9836 26.3607 44.605Z",
    fill: "#FFD336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M502.699 20.12C503.011 20.4821 504.197 20.8503 504.546 21.0027C505.017 21.171 506.099 21.4185 506.392 21.8855C505.06 20.2114 505.007 18.3813 505.895 16.8877C506.764 15.4989 507.982 14.2625 507.336 12.2483C507.25 12.0227 505.716 11.502 505.489 11.3655C505.263 11.2289 503.729 10.7083 503.643 10.4827C504.29 12.497 503.072 13.7333 502.202 15.1221C501.296 16.7206 501.368 18.4459 502.699 20.12Z",
    fill: "#FFD336"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M572.256 13.6913C572.466 11.788 569.023 11.449 568.813 13.3523C568.604 15.2557 572.047 15.5947 572.256 13.6913Z",
    fill: "#FFD336"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M568.42 45.4726C568.63 43.5693 565.187 43.2303 564.977 45.1336C564.646 47.0211 568.089 47.3601 568.42 45.4726Z",
    fill: "#3CA8F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M592.501 26.4281C592.402 27.7022 594.622 27.8827 594.843 26.6244C594.942 25.3503 592.6 25.1539 592.501 26.4281Z",
    fill: "#F42B75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M528.19 0.364602L525.377 0C525.859 0.813274 527.327 1.0035 528.19 0.364602Z",
    fill: "#3CA8F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M513.995 36.4344C513.785 38.3377 517.229 38.6767 517.438 36.7734C517.648 34.8701 514.204 34.5311 513.995 36.4344Z",
    fill: "#3CA8F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M420.257 33.6703C420.158 34.9444 422.378 35.1249 422.599 33.8666C422.698 32.5925 420.356 32.3961 420.257 33.6703Z",
    fill: "#3CA8F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M492.261 11.9047C492.162 13.1788 494.382 13.3593 494.603 12.101C494.702 10.8268 492.36 10.6305 492.261 11.9047Z",
    fill: "#FFD336"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M567.003 28.35L565.952 26.4979L564.887 28.2902L562.452 28.6182L564.206 30.0253L563.715 32.1066L565.875 31.2068L567.966 32.1213L567.564 30.1387L569.327 28.6512L567.003 28.35Z",
    fill: "#00DDC8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M446.786 5.15321C447.363 3.29745 443.993 2.53901 443.417 4.39477C442.841 6.25053 446.088 6.99311 446.786 5.15321Z",
    fill: "#FF639E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M488.705 40.8393C488.62 40.6137 487.293 40.3345 487.048 40.3028C486.804 40.2711 485.477 39.9918 485.391 39.7663C485.885 41.2245 484.6 42.1305 483.786 43.2046C482.831 44.3678 482.836 45.7627 483.893 46.865C484.101 47.1064 485.202 47.2491 485.55 47.4015C485.899 47.5539 486.877 47.6807 487.207 47.938C486.15 46.8357 486.145 45.4409 487.1 44.2777C488.037 43.2193 489.2 42.2976 488.705 40.8393Z",
    fill: "#FFD336"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M535.187 56.1264L533.827 54.4297L533.085 56.3385L530.734 56.9748L532.713 58.1413L532.59 60.2623L534.569 59.0957L536.795 59.732L536.053 57.8232L537.538 56.1264L535.187 56.1264Z",
    fill: "#00DDC8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M379.088 25.1771C379.212 26.4496 381.438 26.3436 381.438 25.071C381.314 23.7985 379.088 23.9045 379.088 25.1771Z",
    fill: "#F42B75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.667 13.4388C217.791 14.7113 220.017 14.6053 220.017 13.3327C219.893 12.0602 217.543 12.1662 217.667 13.4388Z",
    fill: "#F42B75"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M356.081 14.6029C356.205 16.5118 359.669 16.4057 359.545 14.4969C359.421 12.5881 355.958 12.6941 356.081 14.6029Z",
    fill: "#3CA8F1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M284.793 21.6967L283.432 20L282.69 21.9088L280.34 22.5451L282.319 23.7116L282.195 25.8326L284.174 24.6661L286.401 25.3023L285.659 23.3935L287.143 21.6967H284.793Z",
    fill: "#00DDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationBackground);
export default __webpack_public_path__ + "static/media/CelebrationBackground.8436ce4d28be86337034de3bb7f33686.svg";
export { ForwardRef as ReactComponent };